import React, { useState } from 'react'

function Nav() {
  const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = ()=>{
        setIsOpen(!isOpen);
        console.log("Clicked")
    }
  return (
    
    <nav className="bg-neutral-100 border border-neutral-300 z-50 fixed top-0 left-0 right-0">
      <div className="mx-auto max-w-screen-lg px-2 sm:px-6 lg:px-8">
        <div className="relative flex h-16 items-center justify-between">
          <div className="absolute  left-0 flex items-center sm:hidden">
    
            <div>
              <button onClick={toggleMenu} className="relative group z-20" id="mobile-menu-button">
                <div className="relative flex flex-col overflow-hidden items-center justify-center w-[40px] h-[40px] transform transition-all bg-primaryGreen ring-0 ring-gray-300 hover:ring-8 group-focus:ring-4 ring-opacity-30 duration-200 shadow-md -z-10">
                  <div className="transform transition-all duration-150 overflow-hidden -translate-y-5 group-focus:translate-y-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6h-6 w-6 animate-bounce text-white pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
    
                  <div className="flex flex-col justify-between w-[20px] h-[20px] transform transition-all duration-300 origin-center overflow-hidden -translate-y-3">
                    <div className="bg-white mb-1.5 h-[2px] w-7 transform transition-all duration-300 origin-left group-focus:translate-y-6"></div>
                    <div className="bg-white mb-1.5 h-[2px] w-7 rounded transform transition-all duration-300 group-focus:translate-y-6 delay-75"></div>
                    <div className="bg-white h-[2px] w-7 transform transition-all duration-300 origin-left group-focus:translate-y-6 delay-100"></div>
                  </div>
                </div>
              </button>
            </div>
    
          </div>
    
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start relative">
            <div className="flex flex-shrink-0 items-center">
              <a href="/" className="text-black font-bold z-30">B.Danny</a>
            </div>
            {/* <!-- Desktop Menu--> */}
            <div
                className={`fixed top-0 right-0 left-0 bottom-0 bg-gray-100 pl-5 pt-[6rem]  ${
                isOpen ? 'translate-x-0' : 'translate-x-full'
                } duration-1000 ease-in-out sm:relative sm:translate-x-10 sm:bg-transparent sm:pl-0 sm:pt-0 sm:ml-6 sm:block`}
            >
            {/* <div 
              className={`fixed top-0 right-0 left-0 bottom-0 bg-gray-100 pl-5 pt-[6rem] || sm:pl-0 sm:pt-0 sm:ml-6 sm:block`}
            > */}
              <ul className="flex space-y-5 sm:space-y-0 flex-col sm:flex-row space-x-4">
                  <li>
                      <a href={`/`} className="text-gray-900 px-7 sm:px-3 py-2 text-2xl sm:text-sm font-medium hover:underline" aria-current="page">Home</a>
                  </li>
                  <li>
                      <a href={`/about`} className="text-gray-900 px-3 py-2 text-2xl sm:text-sm font-medium hover:underline">About</a>
                  </li>
                  <li>
                      <a href={`/projects`} className="text-gray-900 px-3 py-2 text-2xl sm:text-sm font-medium hover:underline">Projects</a>
                  </li>
                  <li>
                      <a href={`/articles`} className="text-gray-900 px-3 py-2 text-2xl sm:text-sm font-medium hover:underline">Blog</a>
                  </li>
              </ul>
            </div>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 text-base">
    
            <div className="relative ml-3">
              <div >
                <a href="https://www.linkedin.com/in/danny-baraka/" target="_blank" rel="noreferrer"  className="flex gap-1 hover:text-gray-600 text-base text-[#0077b5]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 72 72" id="linkedin"><g fill="none" fill-rule="evenodd">
                      <rect width="72" height="72" fill="#117EB8" rx="4"></rect>
                      <path fill="#FFF" d="M13.139 27.848h9.623V58.81h-9.623V27.848zm4.813-15.391c3.077 0 5.577 2.5 5.577 5.577 0 3.08-2.5 5.581-5.577 5.581a5.58 5.58 0 1 1 0-11.158zm10.846 15.39h9.23v4.231h.128c1.285-2.434 4.424-5 9.105-5 9.744 0 11.544 6.413 11.544 14.75V58.81h-9.617V43.753c0-3.59-.066-8.209-5-8.209-5.007 0-5.776 3.911-5.776 7.95V58.81h-9.615V27.848z"></path>
                      </g>
                  </svg>
                  <p>Linkedin</p>
                </a>
              </div>
            </div>

            <div className="relative ml-3 hidden md:flex">
              <div >
                <a href="https://github.com/barakadanny" target="_blank" rel="noreferrer"  className="flex gap-1 hover:text-gray-600 text-base text-[#171515]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" className='mt-1'>
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                  Github
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

  )
}

export default Nav
